import { ContainerTypeLoader } from './ContainerTypeLoader';

export const containerTypeLoader: { (token?: string): ContainerTypeLoader } = (token) =>
  new ContainerTypeLoader(token);
